<mojo-lister entityName="TenantParent"
             [ownerEntityKey]="entityKey$ | async"
             (onRowSelect)="handleRowSelect($event)"
             [getRowHref]="getRowHref">
</mojo-lister>
